import { ArtOrderOffer } from "@/api/art-order/types";
import { Button } from "@/app/(components)/Basic/Button";
import { useSuccessModal } from "@/app/(components)/Basic/SuccessModal/context/context";
import CancelIcon from "@/assets/icons/cancel.svg";
import useWalletSignedFunction from "@/shared/hooks/useWalletSignedFunction";
import { useState } from "react";
import { CancelArtOrderModal } from "../CancelArtOrderModal";
import { ProgressContextProvider } from "@/app/(components)/Basic/ProgressModal/context";

export interface Props {
  artOrderOffer: ArtOrderOffer;
}

export default function CancelArtOrderButton({ artOrderOffer }: Props) {
  const [isCancelConfirm, setIsCancelConfirm] = useState<boolean>(false);

  const { setSuccessData } = useSuccessModal();

  const onSuccess = () => {
    setSuccessData({
      item: {
        name: "",
        media: "",
      },
      title: "Cancel art order",
      text: "You canceled order",
      buttonText: "View art orders",
      redirectUrl: `/nft/nest`,
    });

    setIsCancelConfirm(false);
  };

  const checkedCancelConfirm = useWalletSignedFunction(() =>
    setIsCancelConfirm(true),
  );

  return (
    <ProgressContextProvider>
      <Button
        onClick={checkedCancelConfirm}
        className="text-red"
        startIcon={<CancelIcon className="fill-red" />}
      >
        Cancel order
      </Button>
      {isCancelConfirm ? (
        <CancelArtOrderModal
          artOrderOffer={artOrderOffer}
          onSuccess={onSuccess}
        />
      ) : null}
    </ProgressContextProvider>
  );
}
